import React, { useRef, useState, useEffect } from 'react';
// import { useDetailsContext } from '../details';
import DataTable from 'react-data-table-component';
import { useWindowSize } from '../../../services/helpers';
import {
  distanceInPreferredUnit,
  elevationInPreferredUnit,
  paceInPreferredUnit,
} from "../../../services";

import './waypoint-table.css';
import { WaypointsExpanded } from './WaypointsExpanded';
import { WaypointsColumns } from './WaypointsColumns';
import { rowCollapsedElement, rowExpandedElement, headerFontStyle, waypointFontStyle, tableCustomStyles } from './WaypointsTableStyles';

const WaypointTable = ({ waypoints, route, userPrefUnits, handleActiveWaypoint}) => {
  // const [state, dispatch] = useDetailsContext();
  const [wptData, setWptData] = useState([]);

  const ref = useRef(null);
  const size = useWindowSize(ref);

  const handlerRowClick = (wpt) => {
    // console.log(wpt);
    const payload = {
      id: wpt.id,
      lat: wpt.lat,
      lon: wpt.lon,
      elapsedTime: wpt.elapsedTime,
      description: wpt.description,
      title: wpt.title,
      type: 'table',
    };
    handleActiveWaypoint(payload);
    // dispatch({ type: 'SET_ACTIVE_WAYPOINT', payload: payload });
  };

  let properVH = 0;
  // console.log(window.innerHeight)
  let vh = (100 / window.innerWidth) * window.innerHeight;
  if (window.innerHeight > 950) {
    // let vh = (100 / window.innerWidth) * window.innerHeight;
    properVH = +Math.min(vh, 50) + 'vh';

  } 
  else if (window.innerHeight > 800) {
    properVH = +Math.min(vh, 42) + 'vh';
  }
  else {
    properVH = '35vh';
  }

  useEffect(() => {
    const waypointData = waypoints.map((marker) => {
      const p = Math.floor(paceInPreferredUnit(marker.pace));
      const pace = isNaN(p)
        ? '00:00'
        : new Date(p * 1000).toISOString().substring(11, 19);
      const [time] = marker.time.split('.');

      let currLat = null;
      let currLon = null;
      let cumAscent = null;
      let cumDescent = null;

      if (
        route && route.length > marker.index
      ) {
        currLat = route[marker.index].lat;
        currLon = route[marker.index].lon;
        cumAscent = route[marker.index].cumulatedAscent;
        cumDescent = route[marker.index].cumulatedDescent;
      }
      return {
        title: marker.title,
        distance: `${Math.round((distanceInPreferredUnit(marker.distance) * 100) / 1000) / 100} [${
          Math.round((distanceInPreferredUnit(marker.secDist) * 100) / 1000) / 100 }]`,
        distance_short: `${Math.round((distanceInPreferredUnit(marker.distance) * 100) / 1000) / 100}`,
        distance_section: `${Math.round((distanceInPreferredUnit(marker.secDist) * 100) / 1000) / 100}`,
        gradeChange: `+${Math.round(marker.gradeUpHill)}% / ${Math.round(marker.gradeDownHill)}%`,
        elevChange: `+${Math.round(elevationInPreferredUnit(marker.elevGain))} / ${Math.round(
          elevationInPreferredUnit(marker.elevLoss))}`,
        type: `${marker.type}`,
        pace: pace,
        time: time,
        elapsedTime: marker.elapsedTime,
        secDist: Math.round((distanceInPreferredUnit(marker.secDist) * 100) / 1000) / 100,
        description: marker.description,
        lat: currLat,
        lon: currLon,
        id: marker.id,
        cumAscent: `+${Math.round(elevationInPreferredUnit(cumAscent))}`,
        cumDescent: `${Math.round(elevationInPreferredUnit(cumDescent))}`,
      };
    });
    setWptData(waypointData);
  }, [waypoints, route, userPrefUnits]);

  const customSVGobj = {
    collapsed: rowCollapsedElement,
    expanded: rowExpandedElement,
  };
  return (
    <div className='waypoint-table-component' ref={ref}>
      <DataTable
        noHeader={true}
        columns={WaypointsColumns({"headerFontStyle": headerFontStyle, "waypointFontStyle": waypointFontStyle,"summaryUnitLabels": userPrefUnits, "size": size })}
        data={wptData}
        highlightOnHover={true}
        sortable={false}
        compact={true}
        fixedHeader
        fixedHeaderScrollHeight={properVH}
        expandableRows={true}
        expandOnRowClicked={true}
        expandableRowsComponent={ WaypointsExpanded }
        expandableRowsComponentProps={{"userPrefUnits": userPrefUnits, "size": size, "headerFontStyle": headerFontStyle}}
        theme="waldup"
        customStyles={tableCustomStyles}
        onRowClicked={(e) => {
          handlerRowClick(e);
        }}
        expandableIcon={customSVGobj}
      />
    </div>
  );
};

export default WaypointTable;
